import {GoAFormItem} from "@abgov/react-components";
import {FC} from "react";
import DecimalInput from "../../../../components/DecimalInput/DecimalInput";
import {IFlightReport} from "../../../../model/IFlightReport";
interface IDailyWorkPeriodProps {
    flightReport: IFlightReport;
    isEdit?: boolean;
    onChange: (updatedFields: Partial<IFlightReport>) => void;
}
const DailyWorkPeriod: FC<IDailyWorkPeriodProps> = ({
    flightReport,
    isEdit,
    onChange,
}) => {
    function formatDailyWorkPeriod() {
        return flightReport.dailyWorkPeriod
            ? Number(flightReport.dailyWorkPeriod).toFixed(1)
            : "-";
    }
    return (
        <GoAFormItem label="Daily Work Period (hrs)">
            <div>
                {isEdit && (
                    <DecimalInput
                        value={
                            flightReport.dailyWorkPeriod
                                ? flightReport.dailyWorkPeriod
                                : ""
                        }
                        numDecimals={1}
                        max={24}
                        disabled={false}
                        onChange={(newValue: string) => {
                            onChange({
                                dailyWorkPeriod: newValue,
                            });
                        }}
                    />
                )}
                {!isEdit && <label>{formatDailyWorkPeriod()}</label>}
            </div>
        </GoAFormItem>
    );
};
export default DailyWorkPeriod;
